import { Component, inject } from '@angular/core';
import { UserEnvironment, UserService } from 'projects/lib-shared-core/src/public-api';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'svc-registry-modal-header',
  templateUrl: './svc-registry-modal-header.component.html',
  styleUrls: ['./svc-registry-modal-header.component.scss'],
})
export class SvcRegistryModalHeaderComponent {
  #userService: UserService = inject(UserService);
  #dialogRef: MatDialogRef<unknown> = inject(MatDialogRef);

  public environment: UserEnvironment = this.#userService.environment;

  closeDialog(): void {
    this.#dialogRef.close();
  }
}
